var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0123 6.0123C13.0122 5.81455 12.9536 5.62125 12.8437 5.45684C12.7338 5.29243 12.5776 5.16429 12.3949 5.08862C12.2122 5.01295 12.0112 4.99315 11.8173 5.03171C11.6233 5.07028 11.4451 5.16549 11.3053 5.3053L8.01229 8.5983L4.71929 5.3053C4.62704 5.20979 4.5167 5.13361 4.39469 5.0812C4.27269 5.02879 4.14147 5.0012 4.00869 5.00005C3.87591 4.99889 3.74423 5.0242 3.62133 5.07448C3.49844 5.12476 3.38679 5.19901 3.29289 5.2929C3.199 5.3868 3.12475 5.49845 3.07447 5.62134C3.02419 5.74424 2.99888 5.87592 3.00004 6.0087C3.00119 6.14148 3.02878 6.2727 3.08119 6.3947C3.1336 6.51671 3.20978 6.62705 3.30529 6.7193L7.30529 10.7193C7.49282 10.9068 7.74712 11.0121 8.01229 11.0121C8.27745 11.0121 8.53176 10.9068 8.71929 10.7193L12.7193 6.7193C12.9068 6.53181 13.0122 6.27749 13.0123 6.0123Z",
    fill: "#4A4A68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdown);
export default __webpack_public_path__ + "static/media/arrowdown.43bb60467925abf7a4670895ed27ad03.svg";
export { ForwardRef as ReactComponent };